import { HTMLAttributes, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface Props extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode
}

export function Root({ children, ...rest }: Props) {
    return (
        <div className={twMerge("tw-w-full tw-h-full tw-flex tw-flex-col tw-pl-[330px] tw-pt-16", rest.className)}>
            {children}
        </div>
    )
}